<script>
import ImageMixin from '@src/mixins/imageMixin.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    step: {
      type: Object
    },
    orderingNum: {
      type: Number
    }
  },
  mixins: [
    ImageMixin
  ],
  computed: {
    ...mapGetters('plan', [
      'appLinks',
    ]),
  }
}
</script>

<template>
  <div class="content">
    <div class="step-img" :style="getBackground(step.image[0])">
      <template v-if="orderingNum === 1">
        <!-- temporarily -->
        <!-- <a class="link" :href="appLinks && appLinks[1]" target="_blank"> -->
        <a class="link" href="https://apps.apple.com/us/app/prague-cool-pass/id1378275600" target="_blank">
          <div></div>
        </a>
        <!-- temporarily -->
        <!-- <a class="link" :href="appLinks && appLinks[0]" target="_blank"> -->
        <a class="link" href="https://play.google.com/store/apps/details?id=com.bookletia.coolpassprague" target="_blank">
          <div></div>
        </a>
      </template>
    </div>
    <div class="ordering">
      {{ orderingNum }}
    </div>
    <div class="step-hint">
      {{ step.caption }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.content {
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.step-img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 269px;
  height: 250px;

  .link {
    height: 50px;
    width: 180px;
    margin: 15px;
  }
}

.ordering {
  margin-top: 14px;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-style: normal;
  font-size: 22px;
  line-height: 29px;
  text-align: center;
  color: $dark-blue;
}

.step-hint {
  // height: 92px;
  margin-top: 7px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: center;
  // color: rgb(37, 37, 39, 0.8);
  color: $dark-blue;
}

$scale: 0.93;
$gap: 20;

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .step-img {
    height: 250px;
    width: 100%;
  }

  .step-hint,
  .ordering {
    width: 288px;
  }
}
</style>
